<div
  class="dropzone"
  appDnd
  (filesDrop)="onFilesDrop($event)">
  <fa-icon
    [icon]="faUpload"
    class="u-color--primary u-mb--medium"
    size="2x"></fa-icon>
  <p class="dropzone__line u-mb--medium">
    {{ "dragndrop.dropfilehere" | translate }}
  </p>
  <p class="dropzone__line u-mb--medium">{{ "dragndrop.or" | translate }}</p>
  <a
    type="button"
    class="button button--sm button-secondary"
    >{{ "dragndrop.browse" | translate }}</a
  >
  <input
    type="file"
    [accept]="allowedFileTypes"
    #fileDropRef
    id="fileDropRef"
    class="dropzone__input"
    (change)="onFileInput($event)" />
</div>
<div
  *ngIf="fileToUpload"
  class="files-list">
  <div class="single-file">
    <div class="file-icon">
      <fa-icon
        [icon]="faFilePdf"
        size="2x"
        class="u-color--primary"></fa-icon>
    </div>
    <div class="info">
      <h4 class="name">
        {{ fileToUpload?.name }}
      </h4>
    </div>
  </div>
</div>
